export default __webpack_public_path__ + "static/media/wilogics2.db6281a3.jpg";